import React, { useEffect } from "react";
import TaskForm from "../forms/TaskForm";
import Button from "../../ui/Button";

/**
 * Nested modal for editing a single task with its subtasks
 * Opens over the parent TaskSet modal/page
 */
const TaskBuilderModal = ({
  isOpen,
  onClose,
  onSave,
  task = null,
  mode = "project",
  showSaveToRegistry = false
}) => {
  const [formData, setFormData] = React.useState({
    name: "",
    description: "",
    weight: 1,
    estimatedHours: "",
    tags: [],
    subTasks: [],
    saveToRegistry: false
  });

  useEffect(() => {
    if (isOpen && task) {
      // Editing existing task
      setFormData({
        ...task,
        tags: task.tags || [],
        subTasks: task.subTasks || [],
        saveToRegistry: task.saveToRegistry || false
      });
    } else if (isOpen && !task) {
      // Creating new task
      setFormData({
        name: "",
        description: "",
        weight: 1,
        estimatedHours: "",
        tags: [],
        subTasks: [],
        saveToRegistry: false
      });
    }
  }, [isOpen, task]);

  // Lock body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen]);

  const handleSave = () => {
    if (!formData.name?.trim()) {
      alert("Task name is required");
      return;
    }

    // Process tags if they're a string
    const processedData = {
      ...formData,
      tags: typeof formData.tags === "string" 
        ? formData.tags.split(",").map(t => t.trim()).filter(Boolean)
        : formData.tags
    };

    onSave(processedData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h2 className="text-xl font-bold mb-4">
            {task ? "Edit Task" : "New Task"}
          </h2>

          <TaskForm
            value={formData}
            onChange={setFormData}
            mode={mode}
            showSaveToRegistry={showSaveToRegistry}
          />

          <div className="flex justify-end gap-2 mt-6 pt-4 border-t">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="solid" onClick={handleSave}>
              Save Task
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskBuilderModal;
